// @flow

import React, { type Node } from 'react';
import { Badge } from './countdown-badge.styles';

const DEFAULT_BADGE_TEXT = 'CONFIRME EM ATÉ 15 MINUTOS';

type CountdownBadgeProps = {|
  +text?: string,
|};

export function CountdownBadge({ text }: CountdownBadgeProps): Node {
  return (
    <Badge>{text || DEFAULT_BADGE_TEXT}</Badge>
  );
}
